<template>
  <v-dialog
    :value="active"
    max-width="500"
    @click:outside="$emit('dialog:change', 'cerrar')"
  >
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card elevation="10" v-show="active" height="auto" width="auto" class="mx-auto">
        <v-card-title class="pa-0 shadow-1">
          <v-card-title class="font-weight-medium primary--text">
            Actualizar {{ isChildren ? "Hijo" : "Tipificacion" }}
          </v-card-title>
        </v-card-title>

        <v-card-text class="py-2">
          <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
            <v-text-field
              :error-messages="errors"
              class="px-2 pt-3"
              label="Nombre"
              name="nombre"
              prepend-inner-icon="mdi-account"
              autofocus
              v-model="name"
              required
              filled
              rounded
              dense
              clearable
            >
            </v-text-field>
          </ValidationProvider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-5"
              @click="handleSubmit(EditItem)"
            >
              Actualizar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="$emit('dialog:change', 'cerrar')"
            >
              Cancelar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
export default {
  props: ["active", "data"],
  data() {
    return {
      name: "",
    };
  },

  computed: {
    isChildren() {
      return (
        Object.prototype.hasOwnProperty.call(this.data, "typification_id") ||
        Object.prototype.hasOwnProperty.call(this.data, "parent_id")
      );
    },
  },

  watch: {
    active(val) {
      if (val) this.name = this.data.name;
      else this.$refs.obs.reset();
    },
  },
  methods: {
    async EditItem() {
      const enviar = { name: this.name };

      if (this.isChildren) {
        enviar.children_id = this.data.id;
      } else {
        enviar.typification_id = this.data.id;
      }

      try {
        const response = await this.$store.dispatch(
          "typifications/EDIT_TYPIFICATIONS",
          enviar
        );
        this.name = "";
        this.$emit("dialog:change", response.data.message);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
